import { RootState } from "../../../redux-store";
import { createSelector } from "@reduxjs/toolkit";

const selectUserSettings = (state: RootState) => state.data.userSettings;

export const selectDefaultDispatcherView = createSelector(
  selectUserSettings,
  (userSettings) => userSettings.defaultDispatcherView
);

export const selectRemoveDropoffByDefault = createSelector(
  selectUserSettings,
  (userSettings) => userSettings.removeDropoffByDefault
);

export const selectDefaultCopyOption = createSelector(
  selectUserSettings,
  (userSettings) => userSettings.defaultCopyOption
);

export const selectDefaultCreateCopyOption = createSelector(
  selectUserSettings,
  (userSettings) => userSettings.defaultCreateCopyOption
);
